<template lang="html">
  <div class="full-page">
    <i-header title="投资者基本信息" @leftClick="$_headerLeftClick">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <cube-form
        class="form-custom"
        :model="Model"
        :options="options">
        <cube-form-group legend="法定代表人或负责人">
          <cube-form-item :field="Fields[0]"></cube-form-item>
          <cube-form-item :field="Fields[1]">
            <div style="text-align:right;">
              {{$_iDCardTypesLabel(Model.representativeDocumentsType)}}
            </div>
          </cube-form-item>
          <cube-form-item :field="Fields[2]"></cube-form-item>
          <cube-form-item :field="Fields[3]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="">
          <cube-form-item :field="Fields[4]"></cube-form-item>
          <cube-form-item :field="Fields[5]"></cube-form-item>
          <cube-form-item v-if="$_isForeign(Model.representativeDocumentsType)" :field="Fields[6]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="" >
          <cube-form-item :field="Fields[7]"></cube-form-item>
          <cube-form-item :field="Fields[8]"></cube-form-item>
          <cube-form-item :field="Fields[9]"></cube-form-item>
          <cube-form-item :field="Fields[10]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="" >
          <cube-form-item :field="Fields[11]"></cube-form-item>
          <cube-form-item :field="Fields[12]"></cube-form-item>
        </cube-form-group>
      </cube-form>
    </i-body>
  </div>
</template>

<script>
import mixin from './config/viewLegalConfig';
import cmixin from '../../commonConfig';

export default {
  mixins: [mixin, cmixin],
  mounted() {
    setTimeout(() => {
      this.$bridge.callHandler('getBaseInfo', { msg: '获取投资者基本信息' }, (data) => {
        const obj = JSON.parse(data);
        console.log('详情', obj);
        this.$_handlerInit(obj.baseInfo);
      });
    }, 300);
  },
  methods: {
    $_handlerInit(data) {
      const obj = JSON.parse(data);
      obj.representativeDocumentsType = this.$_formatOldCatType(obj.representativeDocumentsType);
      obj.legalCountry = obj.legalCountry || '中国'; // 默认 中国
      Object.keys(this.Model).forEach((key) => {
        this.Model[key] = obj[key];
      });
    },
  },
};
</script>
